export default "__VITE_ASSET__BsChGWAI__"